module.exports = __webpack_public_path__ + "static/media/verify-id.568f14dd.jpg";